import { UiFilterModifiers } from '@monorepo/ui';
import { DATE_FILTER_UTIL } from '@monorepo/utils';
import { TDateGroupInfo } from 'libs/ui/src/lib/filter/model/ui-filter.types';
export type TTagFilterConfig = {
  key: string;
  displayName: string;
  items: { value: string; displayName: string }[];
}[];

const getDateFilter = () => {
  const yesterdayDispStr = DATE_FILTER_UTIL.getDateDs({ type: 'YESTERDAY' });
  const weekDispStr = DATE_FILTER_UTIL.getDateDs({ type: 'WEEKLY' });
  const monthDispStr = DATE_FILTER_UTIL.getDateDs({ type: 'MONTHLY' });
  const dateFilter: TDateGroupInfo = {
    type: 'DATE_FILTER',
    key: 'DATE',
    selectedValues: [],
    items: [
      {
        isSelected: false,
        value: 'PAST_ONE_DAY',
        displayText: 'Yestarday: ' + yesterdayDispStr,
      },
      {
        isSelected: false,
        value: 'PAST_ONE_WEEK',
        displayText: 'Week :' + weekDispStr,
      },
      {
        isSelected: false,
        value: 'PAST_ONE_MONTH',
        displayText: 'Month: ' + monthDispStr,
      },
    ],
    text: 'DATE',
  };
  return dateFilter;
};

export const TAG_PP_FILTER_MODEL = {
  createModel: (config: TTagFilterConfig, isReprintTab: boolean) => {
    console.log('config =>', config);
    return UiFilterModifiers.createFilterModelList(
      config,
      (configItem) => {
        return {
          type: 'MULTI_SELECT_FILTER',
          key: configItem.key,
          displayName: configItem.displayName || '-',
          items:
            configItem.items.map((item) => {
              return {
                value: item.value,
                displayName: item.displayName,
                isSelected: false,
              };
            }) || [],
          selectedValues: [],
          preTagForDataDisplay: true,
        };
      },
      isReprintTab && config.length > 0 ? getDateFilter() : undefined,
    );
  },
};
